'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.copyDocument = copyDocument;
exports.copyChapter = copyChapter;
exports.copySchoolLevel = copySchoolLevel;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COPY = 'cms-jai20enmaths/widgets/COPY';
var COPY_SUCCESS = 'cms-jai20enmaths/widgets/COPY_SUCCESS';
var COPY_FAIL = 'cms-jai20enmaths/widgets/COPY_FAIL';

var initialState = {
  copying: false,
  error: undefined,
  report: undefined
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case COPY:
      return (0, _extends3.default)({}, state, {
        copying: true,
        report: undefined
      });
    case COPY_SUCCESS:
      return (0, _extends3.default)({}, state, {
        copying: false,
        error: undefined,
        report: action.result
      });
    case COPY_FAIL:
      return (0, _extends3.default)({}, state, {
        copying: false,
        error: action.error,
        report: undefined
      });
    default:
      return state;
  }
}

function copyDocument(_ref) {
  var documentId = _ref.documentId,
      destChapterId = _ref.destChapterId,
      destDocumentsSectionIndex = _ref.destDocumentsSectionIndex;

  return {
    types: [COPY, COPY_SUCCESS, COPY_FAIL],
    promise: function promise(client) {
      return client.post('/stage/copy_document', {
        data: {
          documentId: documentId,
          destChapterId: destChapterId,
          destDocumentsSectionIndex: destDocumentsSectionIndex
        }
      });
    }
  };
}

function copyChapter(_ref2) {
  var chapterId = _ref2.chapterId,
      destSchoolLevelId = _ref2.destSchoolLevelId;

  return {
    types: [COPY, COPY_SUCCESS, COPY_FAIL],
    promise: function promise(client) {
      return client.post('/stage/copy_chapter', {
        data: {
          chapterId: chapterId,
          destSchoolLevelId: destSchoolLevelId
        }
      });
    }
  };
}

function copySchoolLevel(_ref3) {
  var schoolLevelId = _ref3.schoolLevelId,
      name = _ref3.name,
      shortName = _ref3.shortName,
      slug = _ref3.slug;

  return {
    types: [COPY, COPY_SUCCESS, COPY_FAIL],
    promise: function promise(client) {
      return client.post('/stage/copy_schoollevel', {
        data: {
          schoolLevelId: schoolLevelId,
          name: name,
          shortName: shortName,
          slug: slug
        }
      });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/copy.js
// module id = 198
// module chunks = 0